import { useSelector } from 'react-redux';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import BaseCircleIcon from './BaseCircleIcon';

export default function CircleIcon({
  children,
  className,
  iconClassName = 'text-2xl',
  iconPadding,
}) {
  const { theme } = useSelector((state) => state.ui);
  const { whiteLabelSettings: { secondaryColour, primaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <BaseCircleIcon
      style={{
        backgroundColor: theme.brandColour || secondaryColour,
        fill: primaryColour,
      }}
      className={className}
      iconClassName={iconClassName}
      iconPadding={iconPadding}
    >
      {children}
    </BaseCircleIcon>
  );
}
